import {
  GET_SURVEY_TEMPLATE_QUESTIONS,
  FETCH_SURVEY_TEMPLATE_QUESTION,
  ADD_SURVEY_TEMPLATE_QUESTION,
  UPDATE_SURVEY_TEMPLATE_QUESTION,
  DELETE_SURVEY_TEMPLATE_QUESTION,
  CLEAR_SURVEY_TEMPLATE_QUESTIONS,
  SURVEY_TEMPLATE_QUESTIONS_PAGE,
  CLEAR_ALL,
  SURVEY_TEMPLATE_QUESTIONS_PENDING, // Added pending action type
} from "../constants/actions";

const initialState = {
  survey_template_questions: [],
  pending: false,
  pageNumber: 1,
  created: false,
  updated: false,
};

export default function surveyTemplateQuestions(state = initialState, action) {
  switch (action.type) {
    case SURVEY_TEMPLATE_QUESTIONS_PENDING: // Added pending case
      return {
        ...state,
        pending: true,
      };
    case GET_SURVEY_TEMPLATE_QUESTIONS:
      return {
        ...state,
        survey_template_questions: action.payload,
        pending: false,
      };
    case SURVEY_TEMPLATE_QUESTIONS_PAGE:
      return {
        ...state,
        pageNumber: action.payload,
      };
    case FETCH_SURVEY_TEMPLATE_QUESTION:
      return {
        ...state,
        [action.payload.id]: action.payload,
        pending: false,
      };
    case ADD_SURVEY_TEMPLATE_QUESTION:
      return {
        ...state,
        created: action.payload,
        pending: false,
      };
    case UPDATE_SURVEY_TEMPLATE_QUESTION:
      return {
        ...state,
        [action.payload.id]: action.payload,
        pending: false,
      };
    case DELETE_SURVEY_TEMPLATE_QUESTION:
      return {
        ...state,
        updated: Math.random(),
        pending: false,
      };
    case CLEAR_SURVEY_TEMPLATE_QUESTIONS:
      return {
        ...state,
        ...initialState,
      };
    case CLEAR_ALL:
      return initialState;
    default:
      return state;
  }
}